const Form081EN = {
    stepName: {
        importantNotes: "Important Notes",
        selectSchool: "Type of School",
        partA: "Schools which have not yet established an IMC",
        partB: "Schools which have established an IMC",
        confirmation: "Confirmation",
    },
    noteList: {
        note1: "Note 1: When the last day of no-pay leave is followed by a Sunday or a gazetted public holiday, such Sunday or gazetted public holiday will be regarded as an extension of the period of no-pay leave.  When the last day of such no-pay leave is followed by the major school holidays, i.e. Christmas Holiday, Chinese New Year Holiday, Easter Holiday and Summer Vacation, payment of salary will resume on the day the staff reports to school for duty.  In this connection, the teacher concerned should also include the day(s) which is/are regarded as an extension of the no-pay leave period in his/her application.",
        note2: "Note 2: Prior confirmation from school’s respective School Development Officer is required.",
        note3A: "Note 3: For meeting statutory requirements arising from no-pay leave of (a) to (d), aided schools are reminded to refer to the EDB Circular Memorandum on “Operating Expenses Block Grant (OEBG), Expanded Operating Expenses Block Grant (EOEBG) and Composite Furniture and Equipment Grant for Aided Schools” of the school year and the User Guide of OEBG uploaded on EDB Homepage.",
        note3B: "Note 3: For meeting statutory requirements arising from no-pay leave of (a) to (d), aided schools are reminded to refer to the EDB Circular Memorandum on “Operating Expenses Block Grant (OEBG), Expanded Operating Expenses Block Grant (EOEBG) and Composite Furniture and Equipment Grant for Aided Schools” of the school year and the User Guide of EOEBG uploaded on EDB Homepage.",
        importantNotesStatement:
            "Application/notification of granting no-pay leave to school head/teachersPersonal Information Collection Statement",
        part1Title: "Purpose of Collection",
        importantNotesPurpose:
            "1. The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        importantNotesA:
            "Activities relating to the processing, authentication and counter-checking of the application/notification for granting no-pay leave to school head/teachers;",
        importantNotesB:
            "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application/notification mentioned in (a) above;",
        importantNotesC:
            "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        importantNotesD:
            "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        importantNotesE:
            "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits;",
        importantNotesF:
            "Activities relating to compilation of statistics, research and Government publications; and",
        importantNotesG:
            "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules) and the Codes of Aid.",
        // importantNotesObligatory:
        //     "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        // importantNotesDisclosed:
        //     "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        // importantNotesRights:
        //     "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        // importantNotesConcern:
        //     "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
        checked: "I have checked the relevant documentary proof provided by",
        part2: "2. The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application/notification.",
        part3Title: "Classes of Transferees",
        part3: "3. The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        part3a: "other Government bureau and departments for the purposes mentioned in paragraph 1 above;",
        part3b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        part3c: "where you have given your prescribed consent to such disclosure; and",
        part3d: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong.",
        part4Title: "Access to Personal Data",
        part4: '4. You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to the respective Senior School Development Officer by post to the Regional Education Office at the address on the EDB website (<a href="https://www.edb.gov.hk/en/contact-us/reo.html" target="_blank">https://www.edb.gov.hk/en/contact-us/reo.html</a>) or email to <a href="mailto:edbinfo@edb.gov.hk">edbinfo@edb.gov.hk</a>.',
        and: "and:",
        confirmValid1:
            "confirm valid. [applicable to the type of leave stated in (a) only]",
        confirmValid2:
            "confirm valid. The documentary proof is attached with this form for your further processing of this application. Besides, I have also informed",
        confirmValid2B:
            "confirm valid. I understand that EDB may request my school to provide the documentary proof in respect of the above no-pay leave. Besides, I have also informed",
        confirmValid3:
            "that he/she should report to school for duty on the day following the last day of such no-pay leave to resume the payment of salary. [applicable to types of leave stated in (b) to (e) only]",
        declaration1: "I should be grateful if you would{{addition}}",
        declaration1Option: {
            approval:
                "give approval to the above leave application and keeping open the provident fund account ",
            open: "give approval to keeping open the provident fund account ",
        },
        declarationFrom: "from",
        declarationFrom2:
            "for keeping open his/her provident fund account from",
        declarationTo: "to",
        declaration2:
            "inclusive as a result of his/her taking no-pay leave during the above-mentioned period. His/Her leave will not be counted as continuous contributory service for provident fund purposes.",
        declaration3A:
            "I understand that schools should take own responsibility to fulfill all statutory requirements, including meeting any possible expenditure arising from the no-pay leave of the teaching staff concerned, such as the expenses arising from statutory holidays",
        declaration3B:
            "I also understand that schools should take own responsibility to fulfill all statutory requirements, including meeting any possible expenditure arising from the no-pay leave of the teaching staff concerned, such as the expenses arising from statutory holidays",
        declaration4: "",
    },
    label: {
        msgList: {
            msg1: "To:",
            msg2: "Senior School Development Officer, Regional Education Office",
            msg3: "Duplicate:",
            msg4: "Senior Accounting Officer (Funds), Finance Division",
            msg5: "Triplicate:",
            msg6: "The school",
            msg7: "taking leave",
            msg8: "Dear Sir/Madam,",
            msg9A: "No-pay Leave",
            msg9B: "No Pay Leave",
            msg10: "for School Head/Teachers",
            msg11: "I refer to the application for no-pay leave by",
            msg12: ",",
            msg13: "of my school dated",
            msg14: ".",
            msg15: "I wish to inform you that",
            msg16: "from",
            msg17: "to",
            msg18: "inclusive",
            msg19: "In view of the fact that",
            msg20: "day(s) of no-pay leave,",
            msg20b: "day(s) of no-pay leave, his/her ",
            msg21: " day(s) of no-pay leave, his/her incremental date",
            msg22: "to the first of",
            msg23: ".",
            msg24: ".",
        },

        schoolType: "Please select the type of school",
        date: "Date",
        SSDO: "SSDO",
        nameOfSchool: "Name of School",
        nameOf: "Name of",
        name: "name",
        headOrTeacher: "Head/teacher",
        nameOfHeadOrTeacher: "Name of Head/Teacher",
        title: "Mr/Ms",
        rank: "rank",
        rankWithBracket: "(rank)",
        textBeforeNoPayLeaveDay: "no-pay leave of",
        textAfterNoPayLeaveDay: "day(s)",
        note1: "Note 1",
        onGroundOf: "on ground of",
        sickOrMaternityOrSpecialTubLeave:
            "sick/maternity/special tuberculosis leave",
        fullStop: "of",
        fullStop2: ".",
        comma: ",",
        from: "from",
        studyLeave:
            "study leave for attending education-related course(s). (Please specify)",
        the: "The",
        courseName: "course name",
        organizingIns: "organizing institution",
        healthLeave:
            "leave due to poor health condition with medical documentary proof.",
        redundantLeaveText1: "leave for alleviating the redundancy problem of ",
        redundantLeaveText2: "under the same sponsor",
        note2: "Note 2",
        note3: "Note 3",
        school: "my school/another school",
        otherSchoolName: "please specify the name of the other school",
        otherLeave: "other leave for reasons of personal affairs.",
        plsSpecifyNameOfOtherSchool:
            "(please specify the name of the other school",
        otherReason: "(please specify the reason",
        close: ")",
        reason: "reason",
        approval: "approval",
        ofMySchoolDated: "of my school dated",
        hasBeenGiven: "approval has been given to",
        toTakeNoPayLeaveOf: "to take no-pay leave of",
        hasBeenGranted: "has been granted",
        willBeAdjusted:
            " his/her incremental date will be adjusted to the first of",
        willBeAdjusted2: "incremental date will be adjusted to the first of",
        notifyAsFollows: ".",
        will: "will",
        unchange: "remain unchanged",
    },
    formContent: {
        schoolTypeOption: {
            PartA: "Schools which have not yet established an IMC",
            PartB: "Schools which have established an IMC",
        },
        titleOption: {
            Mr: "Mr",
            Ms: "Ms",
        },
        appliedOrGrantedOption1: {
            applied: "has applied for",
            granted: "has been granted",
        },
        appliedOrGrantedOption2: {
            applied: "has applied for",
            granted: "has been granted",
        },
        headOrTeacherOption: {
            head: "Head",
            teacher: "Teacher",
        },
        leaveOption: {
            sickLeave: "sick leave",
            maternityLeave: "maternity leave",
            specialTubLeave: "special tuberculosis leave",
        },
        mySchoolOrAnotherSchoolOption: {
            mySchool: "my school",
            anotherSchool: "another school",
        },
        adjustedOption: {
            will: "will be adjusted upon approval",
            is: "is adjusted",
        },
        monthOption: {
            1: "January",
            2: "February",
            3: "March",
            4: "April",
            5: "May",
            6: "June",
            7: "July",
            8: "August",
            9: "September",
            10: "October",
            11: "November",
            12: "December",
            na: "not applicable",
        },
        SSDOOption: {
            e: "Hong Kong East District",
            i: "Islands District",
            k: "Kwun Tong District",
            kc: "Kowloon City District",
            kt: "Kwai Chung & Tsing Yi District",
            m: "Central & Western District",
            n: "North District",
            s: "Southern District",
            sk: "Sai Kung District",
            ssp: "Sham Shui Po District",
            st: "Sha Tin District",
            tm: "Tuen Mun District",
            tp: "Tai Po District",
            tw: "Tsuen Wan District",
            w: "Wan Chai District",
            wts: "Wong Tai Sin District",
            y: "Yuen Long District",
            ytm: "Yau Tsim & Mong Kok District",
        },
        numberList: {
            a: "(a)",
            b: "(b)",
            c: "(c)",
            d: "(d)",
            e: "(e)",
        },
    },
    errorMsg: {
        option: "At least one of the grounds provided should be selected",
    },
};

export default Form081EN;
